export default __webpack_public_path__ + "static/media/Facebook.498178f3.svg";